import { render, staticRenderFns } from "./NoteEditorFilterDateSelector.vue?vue&type=template&id=4596a5e9&"
import script from "./NoteEditorFilterDateSelector.vue?vue&type=script&lang=js&"
export * from "./NoteEditorFilterDateSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports